import React from 'react';
import { Link } from 'react-router-dom';
export function ContactRelatedLinks() {
  return <section className="py-12 bg-subtle-gray/30 border-t border-subtle-gray" data-id="element-908">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-909">
        <p className="text-sm font-bold text-gray-warm uppercase tracking-wide mb-6" data-id="element-910">
          Explore More Classes & Programs
        </p>
        <div className="flex flex-wrap justify-center gap-4 md:gap-8" data-id="element-911">
          <Link to="/Programs.html" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-912">
            Classes & Programs
          </Link>
          <Link to="/SignMeUp" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-913">
            Start Trial
          </Link>
          <Link to="/summer-camp" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-914">
            Summer Camp
          </Link>
          <Link to="/Testimonials.html" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-915">
            Reviews
          </Link>
          <Link to="/karate-kids-classes.html" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-916">
            Kids Classes
          </Link>
          <Link to="/karate-adult-classes" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-917">
            Adult Classes
          </Link>
          <Link to="/FamilyKarateClasses.html" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-918">
            Family Classes
          </Link>
        </div>
      </div>
    </section>;
}